export default {
    sessionAllowedMsg: "You are already logged in on 10 devices; logging in here will log you out from the earliest session.",
    passwordExpiredMsg: "Its been more than 90 days since you last changed your password, pls set a new password to continue using the application.",
    mobileEnrollmentMsg: "Your session will expire in 5 mins. Please try again if the session expires",
    passwordExpiringWarning1: "You need to reset your password in the next ",
    passwordExpiringWarning2: " days, to stay compliant with the organization security policy."
}